import React from "react";
import { AiFillHtml5 } from "react-icons/ai";
import {
  BiLogoCss3,
  BiLogoFirebase,
  BiLogoGit,
  BiLogoGithub,
  BiLogoJavascript,
  BiLogoMongodb,
  BiLogoNodejs,
  BiLogoReact,
  BiLogoRedux,
  BiLogoTailwindCss,
  BiLogoTypescript,
  BiLogoVuejs,
} from "react-icons/bi";
import { TbBrandNextjs, TbBrandReactNative } from "react-icons/tb";
import {
  SiDocker,
  SiExpress,
  SiMariadb,
  SiReactquery,
  SiSqlite,
  SiVercel,
} from "react-icons/si";
import { IoLogoElectron } from "react-icons/io5";
import "./experience.css";

const Experience = () => {
  return (
    <section id="experience">
      <h5>The Skills I Have</h5>
      <h2>Skills</h2>
      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Front-end Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BiLogoJavascript color="#f0db4f" size={30} />
              <h4>JavaScript</h4>
            </article>
            <article className="experience__details">
              <BiLogoTypescript
                color="#264de4"
                size={30}
                className="fill-blue-500"
              />
              <h4>Typescript</h4>
            </article>
            <article className="experience__details">
              <BiLogoReact color="#61dbfb" size={30} />
              <h4>ReactJS</h4>
            </article>
            <article className="experience__details">
              <TbBrandNextjs color="#000000" size={30} />
              <h4>NextJS</h4>
            </article>
            <article className="experience__details">
              <BiLogoRedux color="#764abc" size={30} />
              <h4>Redux</h4>
            </article>
            <article className="experience__details">
              <SiReactquery
                color="#be123c"
                size={30}
                className="fill-rose-700"
              />
              <h4>React Query</h4>
            </article>
            <article className="experience__details">
              <SiVercel color="#000000" size={30} className="fill-black" />
              <h4>Vercel</h4>
            </article>
            <article className="experience__details">
              <BiLogoVuejs color="#4fc08d" size={30} />
              <h4>VueJS</h4>
            </article>
          </div>
        </div>
        <div className="experience__backend">
          <h3>Back-end Development</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BiLogoNodejs color="#3c873a" size={30} />
              <h4>NodeJS</h4>
            </article>
            <article className="experience__details">
              <SiExpress color="#ffffff" size={30} />
              <h4>Express</h4>
            </article>
            <article className="experience__details">
              <SiSqlite color="#000000" size={30} className="fill-blue-500" />
              <h4>SQLite</h4>
            </article>
            <article className="experience__details">
              <SiMariadb color="#003545" size={30} />
              <h4>MariaDB</h4>
            </article>
            <article className="experience__details">
              <BiLogoFirebase color="#ffca28" size={30} />
              <h4>Firebase</h4>
            </article>
            <article className="experience__details">
              <BiLogoMongodb color="#4db33d" size={30} />
              <h4>MongoDB</h4>
            </article>
          </div>
        </div>
        <div className="experience__backend">
          <h3>DevOps</h3>
          <div className="experience__content">
            <article className="experience__details">
              <SiDocker color="cyan" size={30} className="fill-blue-400"/>
              <h4>Docker</h4>
            </article>
              
          </div>
        </div>
        <div className="experience__backend">
          <h3>Version Control</h3>
          <div className="experience__content">
            <article className="experience__details">
              <BiLogoGithub color="#ffffff" size={30} />
              <h4>Github</h4>
            </article>
            <article className="experience__details">
              <BiLogoGit color="#f34f29" size={30} />
              <h4>Git</h4>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
